module.exports = __webpack_public_path__ + "img/blue-icon-en(2).d7761835.png";